export const Status_Completed = 'C';
export const Status_Opened = 'O';
export const Status_Expired = 'E';

export const IntStatus_Opened = 0;
export const IntStatus_Completed = 1;
export const IntStatus_Expired = 2;